"use client"
import { initializeStoryblok } from '@/lib/storyblok';
import { StoryblokComponent } from "@storyblok/react";
const Lottie = dynamic(() => import("lottie-react"), { ssr: false });
import initialLoader from "../../assets/main.json"
import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

export function StoryblokRenderer({blok}){
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const timer = setTimeout(() => setLoading(false), 500);
      return () => clearTimeout(timer);
    }, []);

    if (loading || !blok) {
        return (
          <div className="flex justify-center items-center text-center h-[100vh]">
            <Lottie style={{ height: "200px", width: "200px" }} animationData={initialLoader} loop={true} />
          </div>
        );
      }

    return <StoryblokComponent blok={blok}/>
}